export default "__VITE_ASSET__15382dd1__"